// removed by extract-text-webpack-plugin
module.exports = {"gridWidthSection":"_1R_K5","title":"_3CgEG","subtitle":"_13CBG"};